// @ts-nocheck
import { useState } from "react";
import Storage from "classes/Storage/Storage";

/** Same saved account: same employee, or same (non empty) login */
export function sameAccount(a, b) {
	if (!a || !b) return false;
	if (a.employeeId && b.employeeId) return a.employeeId === b.employeeId;
	return !!a.login && a.login === b.login;
}

export default function useAccounts() {
	const storage = new Storage();
	const [Accounts, setAccounts] = useState(getAccounts());

	function saveAccounts(accounts) {
		storage.setItem("Accounts", accounts);
		setAccounts(accounts);
	}

	function getAccounts() {
		const accounts_string = storage.getItem("Accounts");
		let accounts = [];
		try {
			accounts = accounts_string;
		} catch (e) {
			accounts = [];
		}
		return (accounts);
	}

	function getAccount(login_or_id) {
		let accounts = getAccounts();
		if (!accounts?.length)
			return (false);
		let check = accounts.find((a) => ((login_or_id && a.login === login_or_id) || a.employeeId === login_or_id));
		return (check ? check : false);
	}

	function saveAccount(account) {
		let accounts = getAccounts();
		if (!accounts)
			accounts = [];
		let find_index = accounts.findIndex((a) => sameAccount(a, account));
		if (find_index >= 0)
			accounts[find_index] = account;
		else
			accounts.push(account);
		saveAccounts(accounts);
	}

	function removeAccount(login_or_id) {
		let accounts = getAccounts();
		if (!accounts?.length)
			return (true);
		let new_list = accounts.filter((a) => !((login_or_id && a.login === login_or_id) || a.employeeId === login_or_id));
		saveAccounts(new_list);
		return (new_list);
	}

	return ({
		Accounts,
		getAccounts,
		getAccount,
		saveAccount,
		removeAccount
	});
}
